import React from "react";
import { Card, Snackbar } from "@mui/material";

const SnackbarContext = React.createContext(null);

const SnackbarProvider = (props) => {
  const [snackbar, setSnackbar] = React.useState([]);

  React.useEffect(() => {
    if (snackbar.length) {
      const timer = setTimeout(() => {
        setSnackbar((state) => state.slice(0, state.length - 1));
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [snackbar]);

  const saveDesignState = React.useCallback(
    (severity = "success") => {
      setSnackbar((prevState) => [
        ...prevState,
        {
          severity,
          message:
            severity === "success"
              ? "Your design has been saved!"
              : "Your design could not be saved.",
        },
      ]);
    },
    [snackbar]
  );

  const snackbarState = React.useCallback(
    (severity = "success", message = "") => {
      if (!message) return;

      setSnackbar((prevState) => [
        ...prevState,
        {
          severity,
          message,
        },
      ]);
    },
    [snackbar]
  );

  const value = { saveDesignState, snackbarState };

  return (
    <SnackbarContext.Provider value={value}>
      {props.children}
      {snackbar.map((item, index) => (
        <Snackbar
          key={index}
          open={true}
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          sx={{ top: "25px !important" }}
        >
          <Card
            elevation={0}
            sx={{
              background:
                "linear-gradient(90deg, rgba(204,48,69,1) 0%, rgba(234,96,165,1) 20%, rgba(245,225,124,1) 40%, rgba(79,173,91,1) 60%, rgba(50,152,196,1) 80%, rgba(175,145,189,1) 100%)",
              borderRadius: "12px",
              maxWidth: "400px",
            }}
          >
            <Card
              elevation={0}
              sx={{
                borderRadius: "6px",
                margin: "6px",
                padding: "12px",
                textAlign: "center",
              }}
            >
              {item.message}
            </Card>
          </Card>
        </Snackbar>
      ))}
    </SnackbarContext.Provider>
  );
};

export const useSnackbar = () => React.useContext(SnackbarContext);

export default SnackbarProvider;
